import { FC } from "react";

import { useSearchParams } from "next/navigation";

import {
  clearAdminGoogleContext,
  clearJoinGoogleContext,
  getGoogleStytchUrlWithRedirection,
  saveGoogleSsoOriginPath,
  saveJoinGoogleContext,
} from "@/common/helpers/stytch";
import { useTranslate } from "@/common/hooks/useTranslate";
import { DashboardButton } from "@/dashboard-design-system/DashboardButton";
import { GoogleSSOSignUpDataStore } from "@/features/Auth/Register/store/GoogleSSOSignUpDataStore";
import GoogleIcon from "@/icons/illustration/google.svg";

interface StytchSignUpWithGoogleButtonProps {
  label: "signin" | "signup";
  joinEmail?: string;
}

export const StytchGoogleButton: FC<StytchSignUpWithGoogleButtonProps> = ({ label, joinEmail }) => {
  const { t } = useTranslate();
  const searchParams = useSearchParams();
  const query = Object.fromEntries(searchParams?.entries() || []);

  const googleStytchUrl = getGoogleStytchUrlWithRedirection({ searchParams, joinEmail });

  const handleClick = () => {
    if (query.redirectionUrl) {
      GoogleSSOSignUpDataStore.prestoreRedirectionUrl(query.redirectionUrl);
    }
    if (joinEmail) {
      saveJoinGoogleContext({
        joinEmail,
        joinUrl: `${window.location.pathname}${window.location.search}`,
      });
    } else {
      clearJoinGoogleContext();
    }
    clearAdminGoogleContext();
    saveGoogleSsoOriginPath();
  };

  return (
    <DashboardButton
      fullWidth
      variant="outlined"
      vibe="neutral"
      size="large"
      startIcon={<GoogleIcon />}
      href={googleStytchUrl}
      onClick={handleClick}
    >
      {label === "signin" ? t("common", "signin.withGoogle") : t("common", "signup.withGoogle")}
    </DashboardButton>
  );
};
